import {useState} from 'react';
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import Field from "../../Field";
import Alert from "../../../alert/Alert";
import Loading from "../../../generic/Loading";
import {AuthLabel, InfoLabel, SettingsLabel, SftpLabel} from "../../../../config/Config";


const Sftp = (props) => {
    const {journey, currentNode} = props
    const [loading, setLoading] = useState(false)


    const Information = {
        className: 'alert-primary',
        message: `Through this component you can upload data to an SFTP. `,
        docs: {
            message: 'For more information, please ',
            path: '/docs/journeys/sms/'
        }
    }

    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }

    const Title = {
        tab         : 'info',
        name        : 'title',
        type        : 'text',
        label       : 'Title',
        wrapper     : 'form-group',
        placeholder : 'Type an descriptive title',
        defaultValue: SftpLabel,
        node        : currentNode,
    }


    const Description = {
        tab        : 'info',
        name       : 'description',
        type       : 'textarea',
        label      : 'Description',
        wrapper    : 'form-group',
        className  : 'form-control',
        placeholder: 'Type a short description',
        node       : currentNode,
    }



    const Username = {
        tab: 'auth',
        name: 'username',
        type: 'text',
        label: 'Username',
        wrapper: 'form-group',
        placeholder: 'Type username',
        node: currentNode,
        required: true,
    }


    const Password = {
        tab: 'auth',
        name: 'password',
        type: 'password',
        label: 'Password',
        wrapper: 'form-group',
        placeholder: 'Type password',
        node: currentNode,
        required: true,
    }


    const Host = {
        tab: 'settings',
        name: 'host',
        type: 'text',
        label: 'Host',
        wrapper: 'form-group',
        placeholder: 'Type host',
        node: currentNode,
        required: true,
    }


    const Port = {
        tab: 'settings',
        name: 'port',
        type: 'text',
        label: 'Port',
        wrapper: 'form-group',
        placeholder: '22',
        node: currentNode,
        required: true,
    }

    const Path = {
        tab: 'settings',
        name: 'path',
        type: 'text',
        label: 'Path',
        wrapper: 'form-group',
        placeholder: '/var/www/',
        node: currentNode,
        required: true,
    }




    return (
        <div>
            {loading && <Loading />}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        <div className="row">
                                            <div className="col-sm-8">
                                                <Field {...Host}/>
                                            </div>
                                            <div className="col-sm-4">
                                                <Field {...Port}/>
                                            </div>
                                        </div>
                                        <Field {...Path}/>
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_auth'} tabKey={'tab_auth'} tab={AuthLabel}>
                                    <div>
                                        <Field {...Username}/>
                                        <Field {...Password}/>
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Sftp;